import styled from 'styled-components/macro';

export const Button = styled.button`
  font-family: ${({ theme }) => theme.primaryFontMedium};
  font-size: ${({ theme }) => theme.button}px;
  padding: 3px;
`;
